let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("d82zB")).then(() => parcelRequire('cSyHG'));